export default __webpack_public_path__ + "static/media/devops-guild-background.c7fc881b.png";